import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export const KeyGate = ({ onAccessGranted }) => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isDissolving, setIsDissolving] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  const handleSubmit = async () => {
    if (!code.trim() || isLoading || isDissolving) return;
    
    setError('');
    setIsLoading(true);

    const apiUrl = API_URL + '/access/verify';
    console.log('Attempting login to:', apiUrl);

    try {
      const res = await fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code })
      });
      
      console.log('Response status:', res.status);
      const data = await res.json();
      console.log('Response data:', data);
      
      if (data.ok) {
        sessionStorage.setItem('hnc_token', data.token);
        sessionStorage.setItem('hnc_user_type', data.user_type);
        setIsDissolving(true);
        setTimeout(() => onAccessGranted(data), 1300);
      } else {
        setError('Invalid key.');
        setCode('');
        setTimeout(() => setError(''), 1500);
      }
    } catch (err) {
      console.error('Fetch error:', err.message, err);
      setError('Connection error: ' + err.message);
      setCode('');
      setTimeout(() => setError(''), 3000);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <motion.div
      className="key-gate"
      initial={{ opacity: 1 }}
      animate={isDissolving ? { opacity: 0 } : { opacity: 1 }}
      transition={{ duration: 1.3 }}
    >
      <motion.div
        className="entry-curtain"
        initial={{ scaleY: 0 }}
        animate={isDissolving ? { scaleY: 1 } : { scaleY: 0 }}
        transition={{ duration: 1.2, ease: [0.645, 0.045, 0.355, 1] }}
      />
      
      <div className="key-gate-content">
        <motion.div
          className="entry-logo-subtle"
          initial={{ opacity: 0 }}
          animate={isDissolving ? { opacity: 0 } : { opacity: 1 }}
          transition={{ duration: 1.2, delay: isDissolving ? 0 : 0.3 }}
        >
          <img 
            src="https://static.wixstatic.com/media/c29c6a_7a7ac256802147668569a8dde18c3fac~mv2.png/v1/fill/w_310,h_335,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/HNC%20Group%20-%20Logo_Gold_PNG.png" 
            alt="HnC"
            className="entry-logo-image-subtle"
          />
        </motion.div>

        <motion.div
          className="entry-text-stack"
          initial={{ opacity: 0 }}
          animate={isDissolving ? { opacity: 0 } : { opacity: 1 }}
          transition={{ duration: 1, delay: isDissolving ? 0 : 0.6 }}
        >
          <p className="entry-tagline">Admittance by reference.</p>
        </motion.div>

        <motion.div
          className="entry-input-container"
          initial={{ opacity: 0 }}
          animate={isDissolving ? { opacity: 0 } : { opacity: 1 }}
          transition={{ duration: 1, delay: isDissolving ? 0 : 0.9 }}
        >
          <input
            type="text"
            className={`key-input-minimal ${isFocused ? 'focused' : ''}`}
            value={code}
            onChange={(e) => setCode(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && handleSubmit()}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            disabled={isLoading || isDissolving}
            autoFocus
            autoComplete="off"
            spellCheck="false"
          />
          
          <AnimatePresence>
            {error && (
              <motion.p
                className="key-error-minimal"
                initial={{ opacity: 0, y: -5 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.3 }}
              >
                {error}
              </motion.p>
            )}
          </AnimatePresence>
        </motion.div>
      </div>

      <div className="entry-texture" />
    </motion.div>
  );
};
